<!-- header - has to be provided always! -->
<pm-options-header />

<!-- we want to handle the following states -->
<!-- 1. No versionId provided - in queryParam a versionId has to be provided -->
<!-- 2. Fetching - we are fetching the version from the server -->
<!-- 3. Version finished - the version is finished and ready to display -->
<!-- 4. Version failed - the calculation of the version failed. We want to give the user the possibility to delete the failed version and trigger recalculate and select other version -->
<!-- 5. Version calculating - the calculation is still in process. We want to inform the user about the current progress -->
<!-- 6. Version created - the calculation is created, but the calculation has not started yet. -->
<!-- 7. Something went wrong in the backend. We want to inform the user instead of infinite loading. -->

<!-- 1. No versionId provided - in queryParam a versionId has to be provided -->
@if (!this.versionId()) {
  <div class="result-skeleton">
    <div class="chart">
      <pm-no-version-id-provided />
    </div>
  </div>
} @else {
  @switch (this.version()?.status) {
    <!-- 3. Version finished - the version is finished and ready to display -->
    @case (ForecastVersionStatus.FINISHED) {
      @if (this.hasForecastSeriesFailedToFetch()) {
        <!-- handle case 7: version is finished but data fetch failed -->
        <div class="result-skeleton">
          <div class="chart">
            <pm-icon [icon]="AlertIcon"></pm-icon>
            <p>{{ 'RESULT.FAILED_TO_FETCH' | translate }}</p>
          </div>
        </div>
      } @else if (
        this.isForecastSeriesFetching() === false &&
          !isQuickFilterSeriesPending() &&
          latestForecastSeries();
        as forecastSeries
      ) {
        <div class="flex flex-col w-full">
          <pm-version-is-finished-result [forecastSeries]="forecastSeries" />
        </div>
      } @else {
        <!-- 2. Fetching - we are fetching the version from the server -->
        <div class="result-skeleton">
          <div class="chart">
            <pm-version-is-fetching />
          </div>
        </div>
      }
    }

    <!-- 4. Version failed - the calculation of the version failed. We want to give the user the possibility to delete the failed version and trigger recalculate and select other version -->
    @case (ForecastVersionStatus.FAILED) {
      <div class="result-skeleton">
        <div class="chart">
          <p>
            {{
              'UTILITY.CALCULATION_FAILED_SELECT_ANOTHER_VERSION' | translate
            }}
          </p>
        </div>
      </div>
    }

    <!-- 5. Version calculating - the calculation is still in process. We want to inform the user about the current progress -->
    @case (ForecastVersionStatus.CALCULATING) {
      <div class="result-skeleton">
        <div class="chart">
          <pm-version-is-calculating />
        </div>
      </div>
    }

    <!-- 6. Version created - the calculation is created, but the calculation has not started yet. -->
    @case (ForecastVersionStatus.CREATED) {
      <div class="result-skeleton">
        <div class="chart">
          <p>
            {{ 'UTILITY.CREATED_CALCULATION_WILL_START_SOON' | translate }}
          </p>
        </div>
      </div>
    }

    @default {
      @if (this.hasForecastSeriesFailedToFetch()) {
        <!-- fallback: no version status known but fetch failed -->
        <div class="result-skeleton">
          <div class="chart">
            <pm-icon [icon]="AlertIcon"></pm-icon>
            <p>{{ 'RESULT.FAILED_TO_FETCH' | translate }}</p>
          </div>
        </div>
      }
    }
  }
}
